import React from 'react';

export interface FeedbackDisplayProps {
  /** The feedback text submitted by the user */
  feedbackText: string;
}

/**
 * FeedbackDisplay Component
 *
 * Displays submitted feedback text.
 * Shown inline after user successfully submits feedback via the form.
 * Includes "Feedback" header and the user's feedback text.
 */
export const FeedbackDisplay: React.FC<FeedbackDisplayProps> = ({
  feedbackText,
}) => {
  return (
    <div className='mt-4 w-full rounded-lg bg-gray-50 p-4'>
      <div className='flex flex-col gap-3'>
        {/* Header */}
        <h4 className='text-sm font-semibold text-gray-900'>Feedback</h4>

        {/* User's feedback text */}
        <div className='text-sm text-gray-700 whitespace-pre-wrap break-words'>
          {feedbackText}
        </div>
      </div>
    </div>
  );
};
